var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _g2, _path10, _path11, _g3, _path12, _path13, _path14, _path15, _path16, _path17, _g4, _path18, _g5, _g6, _g7, _path19, _g8, _g9, _g10, _g11, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _g12, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _g13, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _g14;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBirthday(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 199.921,
    height: 121.063,
    viewBox: "0 0 199.921 121.063",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Birthday_img",
    "data-name": "Birthday img",
    transform: "translate(-372.297 -676.99)",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25640",
    "data-name": "Group 25640",
    transform: "translate(447.581 732.577)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25639",
    "data-name": "Group 25639",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25631",
    "data-name": "Group 25631",
    transform: "translate(0.726 14.634)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_25623",
    "data-name": "Group 25623",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_140749",
    "data-name": "Path 140749",
    d: "M484.017,813.6l16.909,1.416,14.878-8.158-16.584.115Z",
    transform: "translate(-484.017 -806.863)",
    fill: "#ffad00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_140750",
    "data-name": "Path 140750",
    d: "M509.944,813.23l-15.591-1.4,4.358-1.9,15.535.936Z",
    transform: "translate(-487.747 -807.972)",
    fill: "#00a2d6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_140751",
    "data-name": "Path 140751",
    d: "M498.31,814.546l-4.889-.41,13.205-7.157,5.361-.037Z",
    transform: "translate(-487.411 -806.892)",
    fill: "#00c1ff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_25630",
    "data-name": "Group 25630"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25627",
    "data-name": "Group 25627",
    transform: "translate(0 6.742)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25624",
    "data-name": "Group 25624"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_140752",
    "data-name": "Path 140752",
    d: "M500.926,818.828l7.828,36.907L492.86,852.5l-8.843-35.09Z",
    transform: "translate(-484.017 -817.412)",
    fill: "#ffcb00"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_140753",
    "data-name": "Path 140753",
    d: "M493.642,834.961a35.234,35.234,0,0,1-.66-16.8l-8.965-.751,8.843,35.09,15.893,3.233-1.143-5.387C501.9,848.278,496.325,843.777,493.642,834.961Z",
    transform: "translate(-484.017 -817.412)",
    fill: "#ffcb00",
    opacity: 0.45,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_25626",
    "data-name": "Group 25626",
    transform: "translate(6.01 0.503)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_140754",
    "data-name": "Path 140754",
    d: "M505.978,854.764l-5.019-1.021L493.421,818.2l4.889.409Z",
    transform: "translate(-493.421 -818.199)",
    fill: "#00a2d6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_25625",
    "data-name": "Group 25625",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_140755",
    "data-name": "Path 140755",
    d: "M496.376,818.447l-2.955-.248,2.513,11.85A37.435,37.435,0,0,1,496.376,818.447Z",
    transform: "translate(-493.421 -818.199)",
    fill: "#00a2d6",
    opacity: 0.45,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_140756",
    "data-name": "Path 140756",
    d: "M499.077,844.87h0l3.923,18.5,5.019,1.021-1.7-8A23.736,23.736,0,0,1,499.077,844.87Z",
    transform: "translate(-495.462 -827.824)",
    fill: "#00a2d6",
    opacity: 0.45,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_25629",
    "data-name": "Group 25629",
    transform: "translate(16.909)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25628",
    "data-name": "Group 25628"
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_140757",
    "data-name": "Path 140757",
    d: "M510.474,815.021l7.828,36.907,13.213-9.406-6.162-35.659Z",
    transform: "translate(-510.474 -806.863)",
    fill: "#ffe700"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_140758",
    "data-name": "Path 140758",
    d: "M527.631,870.38a25.837,25.837,0,0,1-6.7-1.433l1.143,5.387Z",
    transform: "translate(-514.249 -829.269)",
    fill: "#ffcb00",
    opacity: 0.45,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_140759",
    "data-name": "Path 140759",
    d: "M526.416,849.914l4.172-2.97L523.05,811.4l-4.3,2.359Z",
    transform: "translate(-513.46 -808.501)",
    fill: "#00c1ff"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_25638",
    "data-name": "Group 25638"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25635",
    "data-name": "Group 25635"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25632",
    "data-name": "Group 25632",
    transform: "translate(0 7.085)"
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_140760",
    "data-name": "Path 140760",
    d: "M493.854,804.882a30.364,30.364,0,0,1-6.058-1.442,12.3,12.3,0,0,1-3.405-1.742,3.549,3.549,0,0,1-1.49-2.537,2.662,2.662,0,0,1,.609-1.828,4.114,4.114,0,0,1,1.062-.9,9.528,9.528,0,0,1,2.054-.863,17.661,17.661,0,0,1,1.834-.4,8.647,8.647,0,0,1,3.984.27,9.76,9.76,0,0,1,5.224,4.14,14.108,14.108,0,0,1,1.83,4.058,10.7,10.7,0,0,1,.336,1.629A34.179,34.179,0,0,1,493.854,804.882Zm5.082-.984a21.935,21.935,0,0,0-2.655-3.188,12.348,12.348,0,0,0-2.046-1.614,7.439,7.439,0,0,0-2.489-1,6.905,6.905,0,0,0-2.765.045,14.5,14.5,0,0,0-1.573.4,6.9,6.9,0,0,0-1.175.542c-.231.1-.2.166-.3.2s.059-.026.033-.067a.193.193,0,0,1,.015-.159c-.128-.294.056.077.343.314a13.255,13.255,0,0,0,2.544,1.528c1.891.89,3.8,1.62,5.435,2.242l4.006,1.505,1.528.621S499.527,804.743,498.936,803.9Z",
    transform: "translate(-482.882 -795.051)",
    fill: "#00c1ff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_140761",
    "data-name": "Path 140761",
    d: "M489.7,801.282c-.279-.125-.559-.252-.838-.383a13.255,13.255,0,0,1-2.544-1.528,1.765,1.765,0,0,1-.218-.221.782.782,0,0,1,.13-.066,6.9,6.9,0,0,1,1.175-.542,14.484,14.484,0,0,1,1.573-.4c.088-.015.176-.029.265-.043a6.849,6.849,0,0,1,2.046-2.934,8.8,8.8,0,0,0-2.831,0,17.643,17.643,0,0,0-1.834.4,9.525,9.525,0,0,0-2.054.863,4.111,4.111,0,0,0-1.062.9,2.662,2.662,0,0,0-.609,1.828,3.549,3.549,0,0,0,1.49,2.537,12.3,12.3,0,0,0,3.405,1.742,30.364,30.364,0,0,0,6.058,1.442h.01A9.741,9.741,0,0,1,489.7,801.282Z",
    transform: "translate(-482.882 -795.052)",
    fill: "#00a2d6",
    opacity: 0.45,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_25634",
    "data-name": "Group 25634",
    transform: "translate(15.572)"
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_140762",
    "data-name": "Path 140762",
    d: "M509.275,800.556a10.606,10.606,0,0,1-.78-1.469,14.1,14.1,0,0,1-1.179-4.293,9.759,9.759,0,0,1,1.384-6.52,8.652,8.652,0,0,1,2.9-2.748,17.638,17.638,0,0,1,1.667-.863,9.552,9.552,0,0,1,2.133-.645,4.119,4.119,0,0,1,1.4.02,2.666,2.666,0,0,1,1.634,1.019,3.551,3.551,0,0,1,.47,2.9,12.318,12.318,0,0,1-1.512,3.513,30.387,30.387,0,0,1-3.748,4.974A34.151,34.151,0,0,1,509.275,800.556Zm0,0,.782-1.452,2.126-3.714c.866-1.524,1.868-3.3,2.757-5.193a13.227,13.227,0,0,0,.986-2.8c.07-.365-.026-.769.064-.46a.192.192,0,0,1,.113.112c.006.049.163,0,.068.031s-.121-.034-.36.04a6.89,6.89,0,0,0-1.25.332,14.573,14.573,0,0,0-1.466.7,6.9,6.9,0,0,0-2.158,1.727,7.416,7.416,0,0,0-1.281,2.357,12.343,12.343,0,0,0-.548,2.547,21.972,21.972,0,0,0-.012,4.149C509.179,799.959,509.275,800.556,509.275,800.556Z",
    transform: "translate(-507.246 -783.965)",
    fill: "#00c1ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_25633",
    "data-name": "Group 25633",
    transform: "translate(0 1.861)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_140763",
    "data-name": "Path 140763",
    d: "M509.107,795.833a12.343,12.343,0,0,1,.548-2.547,6.867,6.867,0,0,1,.531-1.233,7.363,7.363,0,0,1,.938-5.176,8.585,8.585,0,0,0-2.422,2.448,9.759,9.759,0,0,0-1.384,6.52,14.1,14.1,0,0,0,1.179,4.293,10.61,10.61,0,0,0,.78,1.469s-.1-.6-.18-1.625A21.973,21.973,0,0,1,509.107,795.833Z",
    transform: "translate(-507.246 -786.877)",
    fill: "#00a2d6",
    opacity: 0.45,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_140764",
    "data-name": "Path 140764",
    d: "M517.757,797.617a6.462,6.462,0,0,1-3.584,1.2c-.29.521-.574,1.024-.844,1.5l-2.126,3.714-.782,1.452a34.213,34.213,0,0,0,4.362-4.108A31.3,31.3,0,0,0,517.757,797.617Z",
    transform: "translate(-508.392 -790.753)",
    fill: "#00a2d6",
    opacity: 0.45,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_25637",
    "data-name": "Group 25637",
    transform: "translate(14.492 13.751)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25636",
    "data-name": "Group 25636"
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_140765",
    "data-name": "Path 140765",
    d: "M505.563,808.31a2.664,2.664,0,1,0,2.494-2.823A2.663,2.663,0,0,0,505.563,808.31Z",
    transform: "translate(-505.558 -805.482)",
    fill: "#00c1ff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_140766",
    "data-name": "Path 140766",
    d: "M508.964,809.754a2.664,2.664,0,0,1-2.823-2.494c0-.068,0-.135,0-.2a2.662,2.662,0,1,0,4.743,1.694A2.654,2.654,0,0,1,508.964,809.754Z",
    transform: "translate(-505.558 -806.051)",
    fill: "#00a2d6",
    opacity: 0.45,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_140767",
    "data-name": "Path 140767",
    d: "M510.832,807.42c.35.31.768.41.933.223s.015-.589-.335-.9-.768-.41-.933-.223S510.482,807.11,510.832,807.42Z",
    transform: "translate(-507.316 -805.823)",
    fill: "#fff"
  }))))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_140768",
    "data-name": "Path 140768",
    d: "M528.005,811.5l2.751-1.595,3.176,17.377S530.78,812.479,528.005,811.5Z",
    transform: "translate(-499.166 -793.326)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_25646",
    "data-name": "Group 25646",
    transform: "translate(421.736 746.757)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25645",
    "data-name": "Group 25645"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25643",
    "data-name": "Group 25643",
    transform: "translate(0 4.586)"
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_25642",
    "data-name": "Group 25642"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_140769",
    "data-name": "Path 140769",
    d: "M463.349,813.329,451.83,849.48s14.206,5.817,24.664-.56Z",
    transform: "translate(-451.83 -813.329)",
    fill: "#ff4e7e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_25641",
    "data-name": "Group 25641",
    transform: "translate(0 2.799)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_140770",
    "data-name": "Path 140770",
    d: "M459.63,840.667a41.024,41.024,0,0,0,12.71-3.783l-1.708-4.623a37.607,37.607,0,0,1-9.218,2.808Z",
    transform: "translate(-454.645 -822.961)",
    fill: "#ff2c68"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_140771",
    "data-name": "Path 140771",
    d: "M465,824.641a36.539,36.539,0,0,0,5.841-2.311l-1.706-4.621c-.7.319-1.442.628-2.22.922Z",
    transform: "translate(-456.583 -817.709)",
    fill: "#ff2c68"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_140772",
    "data-name": "Path 140772",
    d: "M473.6,850.411l-1.618-4.38a36.961,36.961,0,0,1-15.9,4.781l-1.719,5.4C458.911,855.951,466.841,854.828,473.6,850.411Z",
    transform: "translate(-452.743 -827.93)",
    fill: "#ff2c68"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_140773",
    "data-name": "Path 140773",
    d: "M475.843,863.836l-1.584-4.288a37.5,37.5,0,0,1-22.133,5.682l-.3.93a37.618,37.618,0,0,0,14.6,2.38A32.414,32.414,0,0,0,475.843,863.836Z",
    transform: "translate(-451.83 -832.808)",
    fill: "#ff2c68"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_140774",
    "data-name": "Path 140774",
    d: "M463.51,846.583a37.059,37.059,0,0,1-4.611-11.406l-.3.944-1.784,5.6h0l-1.65,5.176h0l-.778,2.443-2.262,7.1-.3.93.017.007.005,0,.05.02.01,0,.091.036.01,0,.123.047.01,0q.151.057.371.135h0a37.629,37.629,0,0,0,13.915,2.122h0a21.507,21.507,0,0,0,10.06-2.939l-.939-2.542-1.184-3.206C470.8,852.013,466.7,851.5,463.51,846.583Z",
    transform: "translate(-451.83 -821.214)",
    fill: "#ff2c68",
    opacity: 0.45,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_25644",
    "data-name": "Group 25644",
    transform: "translate(8.078)"
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_140775",
    "data-name": "Path 140775",
    d: "M464.611,809.155l1.175,1.13a.456.456,0,0,1,.134.4l-.265,1.608a.457.457,0,0,0,.666.477l1.437-.768a.458.458,0,0,1,.426,0l1.448.749a.457.457,0,0,0,.66-.486l-.286-1.6a.456.456,0,0,1,.129-.405l1.159-1.146a.457.457,0,0,0-.259-.777l-1.614-.224a.456.456,0,0,1-.346-.248l-.731-1.457a.457.457,0,0,0-.819.006l-.712,1.466a.458.458,0,0,1-.342.252l-1.611.245A.457.457,0,0,0,464.611,809.155Z",
    transform: "translate(-464.47 -806.153)",
    fill: "#ffe700"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_140776",
    "data-name": "Path 140776",
    d: "M467.99,810.361a6.465,6.465,0,0,1-.6-3.372l-.577,1.189a.458.458,0,0,1-.342.252l-1.611.245a.457.457,0,0,0-.248.781l1.175,1.13a.456.456,0,0,1,.134.4l-.265,1.608a.457.457,0,0,0,.666.477l1.437-.768a.458.458,0,0,1,.426,0l1.448.749a.457.457,0,0,0,.66-.486l-.2-1.12A1.8,1.8,0,0,1,467.99,810.361Z",
    transform: "translate(-464.47 -806.455)",
    fill: "#ffcb00",
    opacity: 0.45,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_140777",
    "data-name": "Path 140777",
    d: "M471.142,822.809c.741,1.526,1.38,3.084,1.984,4.655s1.169,3.155,1.7,4.75,1.025,3.2,1.472,4.825.869,3.254,1.184,4.92c-.743-1.525-1.383-3.084-1.986-4.654s-1.169-3.155-1.7-4.75-1.024-3.2-1.471-4.825S471.457,824.476,471.142,822.809Z",
    transform: "translate(-458.8 -812.164)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_25672",
    "data-name": "Group 25672",
    transform: "translate(372.297 747.46)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25671",
    "data-name": "Group 25671",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25665",
    "data-name": "Group 25665",
    transform: "translate(0 10.809)"
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_25659",
    "data-name": "Group 25659",
    transform: "translate(0.298)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_140797",
    "data-name": "Path 140797",
    d: "M382.763,816.135l20.717,8.189,21.8-4.572-20.991-4.975Z",
    transform: "translate(-382.763 -814.777)",
    fill: "#ffad00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_140798",
    "data-name": "Path 140798",
    d: "M416.5,822.927l-18.789-7.185,6.081-.384,18.91,6.261Z",
    transform: "translate(-388.157 -814.987)",
    fill: "#ff2c68"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_140799",
    "data-name": "Path 140799",
    d: "M400.519,822.022l-5.893-2.336,18.2-3.332,6.609,1.566Z",
    transform: "translate(-387.044 -815.346)",
    fill: "#ff4e7e"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_25660",
    "data-name": "Group 25660",
    transform: "translate(18.443 4.975)"
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_140800",
    "data-name": "Path 140800",
    d: "M413.727,827.162,411.154,857.4l19.858-6.686,4.165-28.072Z",
    transform: "translate(-411.154 -822.591)",
    fill: "#00c1ff"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_140801",
    "data-name": "Path 140801",
    d: "M414.844,827.133l-.593,6.976,21.508-5.2.889-6.351Z",
    transform: "translate(-412.271 -822.562)",
    fill: "#ffe700"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_140802",
    "data-name": "Path 140802",
    d: "M423.215,855.712l6.271-2.112,2.42-28.444-6.2,1.307Z",
    transform: "translate(-415.507 -823.498)",
    fill: "#ff4e7e"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_140803",
    "data-name": "Path 140803",
    d: "M411.6,868.89l-.442,5.2,5.372-1.809A42.371,42.371,0,0,1,411.6,868.89Z",
    transform: "translate(-411.154 -839.281)",
    fill: "#00a2d6",
    opacity: 0.45,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_25664",
    "data-name": "Group 25664",
    transform: "translate(0 1.358)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25661",
    "data-name": "Group 25661",
    transform: "translate(0 0.11)"
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Path_140804",
    "data-name": "Path 140804",
    d: "M403.312,825.153l-2.572,30.237L382.3,845.446l.637-28.372Z",
    transform: "translate(-382.297 -817.075)",
    fill: "#00a2d6"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_140805",
    "data-name": "Path 140805",
    d: "M388.733,829.756l-5.945-2.561-.492,21.9,18.443,9.945.442-5.2A32.427,32.427,0,0,1,388.733,829.756Z",
    transform: "translate(-382.297 -820.727)",
    fill: "#00a2d6",
    opacity: 0.45,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_25662",
    "data-name": "Group 25662",
    transform: "translate(0.101)"
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Path_140806",
    "data-name": "Path 140806",
    d: "M403.369,825.091l-.593,6.976-20.321-8.755.2-6.41Z",
    transform: "translate(-382.455 -816.902)",
    fill: "#ffcb00"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_140807",
    "data-name": "Path 140807",
    d: "M382.652,816.9l-.2,6.41,3.471,1.5,2.865,1.234a42.946,42.946,0,0,1,.111-6.669l-3.544-1.4h0Z",
    transform: "translate(-382.455 -816.902)",
    fill: "#ffcb00",
    opacity: 0.45,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_25663",
    "data-name": "Group 25663",
    transform: "translate(5.46 2.982)"
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Path_140808",
    "data-name": "Path 140808",
    d: "M396.664,853.152l-5.824-3.14,2.42-28.444,5.893,2.336Z",
    transform: "translate(-390.84 -821.567)",
    fill: "#ff2c68"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_140809",
    "data-name": "Path 140809",
    d: "M392.359,838.129l-1.519,17.86,5.824,3.141.738-8.668A31.909,31.909,0,0,1,392.359,838.129Z",
    transform: "translate(-390.84 -827.544)",
    fill: "#ff2c68",
    opacity: 0.45,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_25670",
    "data-name": "Group 25670",
    transform: "translate(8.218)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25668",
    "data-name": "Group 25668"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25666",
    "data-name": "Group 25666"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_140810",
    "data-name": "Path 140810",
    d: "M403.332,809.258a30.372,30.372,0,0,1-5.08-3.6,12.306,12.306,0,0,1-2.507-2.889,3.546,3.546,0,0,1-.434-2.91,2.664,2.664,0,0,1,1.247-1.467,4.135,4.135,0,0,1,1.323-.442,9.548,9.548,0,0,1,2.228-.033,17.761,17.761,0,0,1,1.85.317,8.649,8.649,0,0,1,3.594,1.739,9.756,9.756,0,0,1,3.3,5.793,14.1,14.1,0,0,1,.181,4.448,10.61,10.61,0,0,1-.3,1.636A34.2,34.2,0,0,1,403.332,809.258Zm5.082.987a22.021,22.021,0,0,0-1.272-3.95,12.294,12.294,0,0,0-1.294-2.261,7.421,7.421,0,0,0-1.936-1.856,6.889,6.889,0,0,0-2.581-.991,14.566,14.566,0,0,0-1.608-.22,6.854,6.854,0,0,0-1.292.064c-.25,0-.25.077-.355.072s.065,0,.056-.05a.19.19,0,0,1,.073-.142c-.009-.321.023.092.2.419a13.251,13.251,0,0,0,1.788,2.369c1.421,1.533,2.916,2.921,4.2,4.111l3.153,2.893,1.186,1.146S408.646,811.249,408.415,810.244Z",
    transform: "translate(-395.155 -797.865)",
    fill: "#ff4e7e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_140811",
    "data-name": "Path 140811",
    d: "M400.828,804.366q-.318-.33-.634-.668a13.251,13.251,0,0,1-1.788-2.369,1.745,1.745,0,0,1-.12-.286.72.72,0,0,1,.146-.013,6.854,6.854,0,0,1,1.292-.064,14.566,14.566,0,0,1,1.608.22l.261.059a6.845,6.845,0,0,1,2.995-1.957,8.807,8.807,0,0,0-2.627-1.057,17.761,17.761,0,0,0-1.85-.317,9.548,9.548,0,0,0-2.228.033,4.135,4.135,0,0,0-1.323.442,2.664,2.664,0,0,0-1.247,1.467,3.546,3.546,0,0,0,.434,2.91,12.306,12.306,0,0,0,2.507,2.889,30.372,30.372,0,0,0,5.08,3.6l.008,0A9.738,9.738,0,0,1,400.828,804.366Z",
    transform: "translate(-395.155 -797.865)",
    fill: "#ff2c68"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_25667",
    "data-name": "Group 25667",
    transform: "translate(14.263 0.318)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_140812",
    "data-name": "Path 140812",
    d: "M417.656,811.614a10.624,10.624,0,0,1-.174-1.653,14.106,14.106,0,0,1,.511-4.423,9.763,9.763,0,0,1,3.722-5.53,8.651,8.651,0,0,1,3.714-1.467,17.972,17.972,0,0,1,1.869-.178,9.533,9.533,0,0,1,2.219.2,4.131,4.131,0,0,1,1.287.539,2.665,2.665,0,0,1,1.134,1.556,3.545,3.545,0,0,1-.649,2.87,12.283,12.283,0,0,1-2.716,2.694,30.335,30.335,0,0,1-5.335,3.212A34.184,34.184,0,0,1,417.656,811.614Zm0,0,1.267-1.055,3.36-2.65c1.372-1.09,2.966-2.363,4.5-3.785a13.234,13.234,0,0,0,1.96-2.229c.2-.313.264-.722.231-.4a.192.192,0,0,1,.063.147c-.012.048.15.065.052.054s-.1-.077-.349-.1a6.906,6.906,0,0,0-1.284-.16,14.631,14.631,0,0,0-1.62.1,6.906,6.906,0,0,0-2.648.8,7.417,7.417,0,0,0-2.069,1.707,12.312,12.312,0,0,0-1.46,2.158,22,22,0,0,0-1.563,3.844C417.79,811.024,417.656,811.614,417.656,811.614Z",
    transform: "translate(-417.472 -798.363)",
    fill: "#ff4e7e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_140813",
    "data-name": "Path 140813",
    d: "M419.658,806.352a12.331,12.331,0,0,1,1.46-2.158,6.868,6.868,0,0,1,.953-.945,7.364,7.364,0,0,1,2.8-4.451,8.582,8.582,0,0,0-3.161,1.366,9.764,9.764,0,0,0-3.722,5.53,14.107,14.107,0,0,0-.511,4.423,10.626,10.626,0,0,0,.174,1.653s.134-.59.44-1.575A22.017,22.017,0,0,1,419.658,806.352Z",
    transform: "translate(-417.472 -798.52)",
    fill: "#ff2c68"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_140814",
    "data-name": "Path 140814",
    d: "M427.5,811.842a6.464,6.464,0,0,1-3.773-.226c-.463.375-.915.736-1.344,1.076l-3.36,2.65L417.76,816.4a34.18,34.18,0,0,0,5.581-2.18A31.25,31.25,0,0,0,427.5,811.842Z",
    transform: "translate(-417.576 -803.146)",
    fill: "#ff2c68"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_25669",
    "data-name": "Group 25669",
    transform: "translate(11.436 10.576)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_140815",
    "data-name": "Path 140815",
    d: "M413.186,816.235a2.664,2.664,0,1,0,3.369-1.685A2.664,2.664,0,0,0,413.186,816.235Z",
    transform: "translate(-413.049 -814.412)",
    fill: "#ff4e7e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_140816",
    "data-name": "Path 140816",
    d: "M416.013,818.516a2.664,2.664,0,0,1-1.686-3.369c.022-.065.048-.126.073-.188a2.662,2.662,0,1,0,3.767,3.344A2.654,2.654,0,0,1,416.013,818.516Z",
    transform: "translate(-413.049 -814.609)",
    fill: "#ff2c68"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_140817",
    "data-name": "Path 140817",
    d: "M418.994,816.974c.209.419.559.667.782.555s.235-.541.026-.959-.559-.667-.782-.556S418.785,816.556,418.994,816.974Z",
    transform: "translate(-415.14 -814.981)",
    fill: "#fff"
  }))))), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Path_140818",
    "data-name": "Path 140818",
    d: "M439.145,835.945l3.878-.918-1.94,13.622S442.334,835.952,439.145,835.945Z",
    transform: "translate(-402.813 -811.276)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_25737",
    "data-name": "Group 25737",
    transform: "translate(484.426 676.99)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25687",
    "data-name": "Group 25687",
    transform: "translate(20.213)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25677",
    "data-name": "Group 25677",
    transform: "translate(0 2.627)"
  }, _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_25673",
    "data-name": "Group 25673"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_140819",
    "data-name": "Path 140819",
    d: "M577.435,710.54s-3-.6-3.608-3.259,1.757-4.068.732-6.181a11.476,11.476,0,0,1,4.235,4.58C579.945,708.432,577.435,710.54,577.435,710.54Z",
    transform: "translate(-573.724 -701.1)",
    fill: "#ffe700"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_140820",
    "data-name": "Path 140820",
    d: "M578.328,712.918a3.6,3.6,0,0,1-1.513-5.228S579.785,709.214,578.328,712.918Z",
    transform: "translate(-574.617 -703.478)",
    fill: "#f2ab09"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_25676",
    "data-name": "Group 25676",
    transform: "translate(1.625 9.102)"
  }, _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_25675",
    "data-name": "Group 25675"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_140821",
    "data-name": "Path 140821",
    d: "M581.488,729.524a1.229,1.229,0,0,1-1.347-.789c-1.031-2.817-4.106-11.31-3.861-11.726.235-.4,2.121-1.155,3.82-1.624a1.224,1.224,0,0,1,1.5.871c.667,2.52,2.232,8.508,2.822,11.356a1.224,1.224,0,0,1-.838,1.418A15.192,15.192,0,0,1,581.488,729.524Z",
    transform: "translate(-576.267 -715.342)",
    fill: "#00c1ff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_25674",
    "data-name": "Group 25674",
    transform: "translate(0.691 0.224)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_140822",
    "data-name": "Path 140822",
    d: "M577.348,719.778c.256.794.562,1.7.887,2.646a9.171,9.171,0,0,0,4.159-4.518c-.153-.583-.289-1.1-.4-1.522a1.22,1.22,0,0,0-.49-.691A9.016,9.016,0,0,1,577.348,719.778Z",
    transform: "translate(-577.348 -715.692)",
    fill: "#00a2d6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_140823",
    "data-name": "Path 140823",
    d: "M584.765,726.06c-.222-.891-.453-1.8-.678-2.681a8.858,8.858,0,0,1-3.987,4.305c.336.947.66,1.846.936,2.608A9.2,9.2,0,0,0,584.765,726.06Z",
    transform: "translate(-578.341 -718.466)",
    fill: "#00a2d6"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_140824",
    "data-name": "Path 140824",
    d: "M578.716,725.3c.082.229.162.454.242.677l.021.059.226.63,0,.01.219.609.027.073c.065.179.127.354.188.52l.011.03h0c.189.522.357.98.49,1.344a1.229,1.229,0,0,0,1.347.789,15.183,15.183,0,0,0,2.1-.494,1.223,1.223,0,0,0,.838-1.417c-.1-.473-.224-1.035-.367-1.651a5.417,5.417,0,0,1-4.371-2.793,15.567,15.567,0,0,1-2.1-6.92,3.468,3.468,0,0,0-1.3.761c-.167.284,1.215,4.336,2.436,7.774Z",
    transform: "translate(-576.266 -715.854)",
    fill: "#00a2d6",
    opacity: 0.45,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_25681",
    "data-name": "Group 25681",
    transform: "translate(11.818 0.321)"
  }, _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Group_25678",
    "data-name": "Group 25678"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_140825",
    "data-name": "Path 140825",
    d: "M595.2,707.291s-2.844-1.115-2.981-3.841,2.442-3.7,1.8-5.957a11.48,11.48,0,0,1,3.367,5.252C598.043,705.656,595.2,707.291,595.2,707.291Z",
    transform: "translate(-592.216 -697.493)",
    fill: "#ffe700"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_140826",
    "data-name": "Path 140826",
    d: "M595.99,709.768a3.6,3.6,0,0,1-.573-5.412S598.073,706.376,595.99,709.768Z",
    transform: "translate(-593.004 -699.97)",
    fill: "#f2ab09"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_25680",
    "data-name": "Group 25680",
    transform: "translate(0.671 9.81)"
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Path_140827",
    "data-name": "Path 140827",
    d: "M596.242,727.01A1.229,1.229,0,0,1,595.054,726c-.522-2.953-2.06-11.854-1.747-12.22s2.29-.765,4.045-.929a1.222,1.222,0,0,1,1.327,1.12c.215,2.6.706,8.767.789,11.675a1.223,1.223,0,0,1-1.073,1.249A15.2,15.2,0,0,1,596.242,727.01Z",
    transform: "translate(-593.266 -712.843)",
    fill: "#ff4e7e"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Group_25679",
    "data-name": "Group 25679",
    transform: "translate(0.246 0.36)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_140828",
    "data-name": "Path 140828",
    d: "M593.65,716.7c.112.826.255,1.775.41,2.76a9.17,9.17,0,0,0,4.887-3.72c-.049-.6-.092-1.135-.128-1.569a1.22,1.22,0,0,0-.361-.766A9.013,9.013,0,0,1,593.65,716.7Z",
    transform: "translate(-593.65 -713.406)",
    fill: "#ff2c68"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_140829",
    "data-name": "Path 140829",
    d: "M599.829,724.168c-.062-.917-.13-1.855-.2-2.758a8.86,8.86,0,0,1-4.68,3.539c.166.991.327,1.933.465,2.731A9.2,9.2,0,0,0,599.829,724.168Z",
    transform: "translate(-594.12 -716.295)",
    fill: "#ff2c68"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_140830",
    "data-name": "Path 140830",
    d: "M598.4,727.189a1.223,1.223,0,0,0,1.073-1.249c-.023-.806-.077-1.866-.149-3.028-3.943-1.929-4.893-6.273-5.052-9.247a2.34,2.34,0,0,0-.96.408,10.28,10.28,0,0,0,.2,2.72h0c.238,1.752.612,4.063.95,6.068l.011.065q.055.324.108.636l.007.042q.054.314.1.612l.019.113c.032.185.063.364.093.536l0,.019c.1.548.18,1.028.247,1.409a1.229,1.229,0,0,0,1.188,1.013A15.213,15.213,0,0,0,598.4,727.189Z",
    transform: "translate(-593.266 -713.139)",
    fill: "#ff2c68",
    opacity: 0.45,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_25686",
    "data-name": "Group 25686",
    transform: "translate(22.101)"
  }, _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Group_25682",
    "data-name": "Group 25682",
    transform: "translate(1.83)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_140831",
    "data-name": "Path 140831",
    d: "M613.168,706.769s-2.472-1.795-1.919-4.468,3.295-2.963,3.245-5.311a11.477,11.477,0,0,1,1.937,5.93C616.328,705.9,613.168,706.769,613.168,706.769Z",
    transform: "translate(-611.169 -696.99)",
    fill: "#ffe700"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_140832",
    "data-name": "Path 140832",
    d: "M613.793,709.252a3.6,3.6,0,0,1,.808-5.382S616.663,706.494,613.793,709.252Z",
    transform: "translate(-611.794 -699.473)",
    fill: "#f2ab09"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_25685",
    "data-name": "Group 25685",
    transform: "translate(0 9.968)"
  }, _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Group_25684",
    "data-name": "Group 25684",
    transform: "translate(0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_140833",
    "data-name": "Path 140833",
    d: "M609.2,726.287a1.229,1.229,0,0,1-.894-1.279c.239-2.99.99-11.992,1.386-12.267.38-.265,2.409-.164,4.149.12a1.222,1.222,0,0,1,1,1.419c-.446,2.567-1.524,8.662-2.175,11.5a1.224,1.224,0,0,1-1.353.938A15.1,15.1,0,0,1,609.2,726.287Z",
    transform: "translate(-608.307 -712.587)",
    fill: "#ffe700"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_25683",
    "data-name": "Group 25683",
    transform: "translate(0.12 0.86)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_140834",
    "data-name": "Path 140834",
    d: "M609.55,715.91c-.1.828-.2,1.782-.3,2.774a9.166,9.166,0,0,0,5.665-2.369c.1-.594.2-1.122.272-1.55a1.22,1.22,0,0,0-.156-.832A9.017,9.017,0,0,1,609.55,715.91Z",
    transform: "translate(-608.768 -713.933)",
    fill: "#ffcb00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_140835",
    "data-name": "Path 140835",
    d: "M613.649,724.675c.171-.9.341-1.828.5-2.719a8.859,8.859,0,0,1-5.42,2.247c-.09,1-.171,1.953-.238,2.76A9.2,9.2,0,0,0,613.649,724.675Z",
    transform: "translate(-608.494 -716.828)",
    fill: "#ffcb00"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_140836",
    "data-name": "Path 140836",
    d: "M610.074,712.653a.947.947,0,0,0-.378.112c-.27.188-.706,4.447-1.031,8.081v0c-.021.238-.042.473-.062.7l-.008.082c-.04.461-.078.9-.113,1.32l0,.05c-.017.2-.034.4-.049.589v.012c-.046.553-.085,1.04-.116,1.426a1.23,1.23,0,0,0,.895,1.279,15.1,15.1,0,0,0,2.114.427,1.224,1.224,0,0,0,1.353-.938c.253-1.1.57-2.693.89-4.38C611.361,719.368,610.441,715.758,610.074,712.653Z",
    transform: "translate(-608.306 -712.611)",
    fill: "#ffcb00",
    opacity: 0.45,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_25736",
    "data-name": "Group 25736",
    transform: "translate(0 19.148)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25734",
    "data-name": "Group 25734"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25699",
    "data-name": "Group 25699",
    transform: "translate(8.723)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25691",
    "data-name": "Group 25691",
    transform: "translate(0 1.602)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25689",
    "data-name": "Group 25689",
    transform: "translate(2.174 5.202)"
  }, _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Group_25688",
    "data-name": "Group 25688"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_140837",
    "data-name": "Path 140837",
    d: "M612.188,751.4q.065-5.3.13-10.6a1.738,1.738,0,0,1-.577.2c-1.31.211-2.371-1.029-3.393-2.229a10.947,10.947,0,0,0-.9-.98,9.7,9.7,0,0,0-2.076.517c-2.121.668-4.761,1.5-6.461-.07-.483-.445-.908-.679-1.131-.63-.258.058-.826.5-1.738,2.769-.26.649-1.04,2.624-2.616,2.7a2.23,2.23,0,0,1-1.87-1,12.709,12.709,0,0,0-1.269,1.9,2.809,2.809,0,0,1-2.089,1.63c-.036,0-.073.007-.109.009-1.468.091-2.676-1.237-4.483-3.225-.335-.368-.69-.759-1.069-1.164-2.02-2.16-3.817-1.331-7.079,1.346-3.02,2.478-5.756,2.02-9.747.306-.96-.412-1.281-.153-2.148,1.733-.54,1.175-1.446,3.142-3.417,2.449a4.069,4.069,0,0,1-1-.52q1.875,6.023,3.751,12.045A234.029,234.029,0,0,1,612.188,751.4Z",
    transform: "translate(-559.148 -737.597)",
    fill: "#ffe700"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_140838",
    "data-name": "Path 140838",
    d: "M564.429,758.016c-.9-.445-1.74-1.025-2.657-1.423l2.075,6.661a234.028,234.028,0,0,1,49.288-7.191q.028-2.279.056-4.558a5.872,5.872,0,0,1-3.455.724,19.323,19.323,0,0,1-4-1.242,5.57,5.57,0,0,0-4.09-.121c-1.522.707-2.339,2.453-3.83,3.222a5.631,5.631,0,0,1-4.717-.229,43.178,43.178,0,0,0-4.429-2.041,4.515,4.515,0,0,0-4.562.813c-.979,1.038-1.281,2.788-2.618,3.288s-2.67-.607-3.9-1.333c-1.885-1.112-4.479-1.325-6.155.082-1.345,1.129-1.956,3.126-3.589,3.772A4.318,4.318,0,0,1,564.429,758.016Z",
    transform: "translate(-560.095 -742.262)",
    fill: "#ffcb00"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_140839",
    "data-name": "Path 140839",
    d: "M574.712,748.272a9.158,9.158,0,0,1,.954-3.146l-.205.167c-3.02,2.478-5.756,2.02-9.747.305-.96-.412-1.281-.153-2.148,1.733-.54,1.175-1.446,3.142-3.417,2.449a4.071,4.071,0,0,1-1-.52q.838,2.693,1.677,5.385l2.075,6.661q11.286-2.9,22.8-4.657C578.811,755.232,574.277,752.2,574.712,748.272Z",
    transform: "translate(-559.148 -740.314)",
    fill: "#ffcb00",
    opacity: 0.45,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_25690",
    "data-name": "Group 25690"
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Path_140840",
    "data-name": "Path 140840",
    d: "M611.387,730.335a2.922,2.922,0,0,0-2.088-.877,178.079,178.079,0,0,0-51.464,7.509,2.95,2.95,0,0,0-2.088,2.9,1.1,1.1,0,0,0,.029.223,5.248,5.248,0,0,0,3.146,4.037c1.971.693,2.877-1.274,3.417-2.449.867-1.886,1.188-2.146,2.148-1.733,3.991,1.714,6.727,2.172,9.747-.305,3.263-2.677,5.059-3.506,7.079-1.346.378.4.734.8,1.069,1.164,1.807,1.988,3.015,3.316,4.483,3.225.036,0,.073-.005.109-.009a2.809,2.809,0,0,0,2.089-1.63,12.709,12.709,0,0,1,1.269-1.9,2.23,2.23,0,0,0,1.87,1c1.576-.079,2.356-2.054,2.616-2.7.911-2.273,1.48-2.711,1.738-2.769.222-.049.648.185,1.131.63,1.7,1.57,4.34.738,6.461.07a9.7,9.7,0,0,1,2.076-.517,10.94,10.94,0,0,1,.9.98c1.022,1.2,2.083,2.44,3.393,2.229a2.117,2.117,0,0,0,1.6-1.48,1.07,1.07,0,0,0,.079-.394l.046-3.735A2.939,2.939,0,0,0,611.387,730.335Z",
    transform: "translate(-555.746 -729.458)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_140841",
    "data-name": "Path 140841",
    d: "M610.888,739.2c-1.325.215-2.4-1.04-3.431-2.254a11,11,0,0,0-.908-.991,9.82,9.82,0,0,0-2.1.523c-2.145.676-4.814,1.516-6.534-.071-.488-.451-.918-.686-1.143-.638-.261.059-.835.5-1.757,2.8-.263.656-1.052,2.654-2.646,2.734a2.255,2.255,0,0,1-1.891-1.009,12.791,12.791,0,0,0-1.283,1.924,2.842,2.842,0,0,1-2.112,1.648l-.111.009c-1.485.092-2.706-1.252-4.533-3.261-.339-.373-.7-.768-1.081-1.177-1.846-1.973-3.506-1.479-6.242.63-2.449,1.721-5.007.32-4.044-2.5a5.571,5.571,0,0,1,1.509-2.211q-7.438,1.555-14.748,3.739a2.95,2.95,0,0,0-2.088,2.9V742h0a1.045,1.045,0,0,0,.028.218,5.248,5.248,0,0,0,3.146,4.037c1.971.693,2.877-1.274,3.417-2.449.867-1.886,1.188-2.146,2.148-1.733,3.991,1.714,6.727,2.172,9.747-.305.153-.126.3-.246.449-.364l.075-.059q.216-.172.423-.331l.056-.043c.292-.222.571-.427.84-.61l.026-.018c.137-.093.271-.181.4-.263l.011-.006a8.5,8.5,0,0,1,.775-.435l0,0c.125-.061.248-.116.369-.165h0a2.964,2.964,0,0,1,3.65.951c.378.4.734.8,1.069,1.164,1.807,1.988,3.015,3.316,4.483,3.225l.109-.009a2.809,2.809,0,0,0,2.089-1.63,12.705,12.705,0,0,1,1.269-1.9,2.23,2.23,0,0,0,1.87,1c1.576-.079,2.356-2.054,2.616-2.7.911-2.273,1.48-2.71,1.738-2.769.222-.049.648.185,1.131.63,1.7,1.57,4.34.738,6.461.07a9.7,9.7,0,0,1,2.076-.517,10.949,10.949,0,0,1,.9.98c1.022,1.2,2.083,2.44,3.393,2.229a2.117,2.117,0,0,0,1.6-1.48,1.069,1.069,0,0,0,.079-.394V738.3A1.924,1.924,0,0,1,610.888,739.2Z",
    transform: "translate(-555.746 -731.587)",
    fill: "#00c1ff",
    opacity: 0.08,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_25698",
    "data-name": "Group 25698",
    transform: "translate(7.149)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25693",
    "data-name": "Group 25693",
    transform: "translate(18.958 4.649)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25692",
    "data-name": "Group 25692"
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Path_140842",
    "data-name": "Path 140842",
    d: "M596.6,736.356a2.007,2.007,0,1,0,1.88-2.128A2.007,2.007,0,0,0,596.6,736.356Z",
    transform: "translate(-596.595 -734.225)",
    fill: "#ffe700"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_140843",
    "data-name": "Path 140843",
    d: "M599.673,737.231a2,2,0,0,1-2.033-2.618,2.006,2.006,0,1,0,2.872,2.375A1.994,1.994,0,0,1,599.673,737.231Z",
    transform: "translate(-596.595 -734.365)",
    fill: "#ffcb00",
    opacity: 0.45,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Path_140844",
    "data-name": "Path 140844",
    d: "M600.9,735.98c.156.252.391.39.523.307s.113-.353-.043-.605-.391-.39-.523-.307S600.744,735.728,600.9,735.98Z",
    transform: "translate(-598.101 -734.631)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_25695",
    "data-name": "Group 25695",
    transform: "translate(33.047)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25694",
    "data-name": "Group 25694"
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Path_140845",
    "data-name": "Path 140845",
    d: "M618.643,729.082a2.007,2.007,0,1,0,1.88-2.128A2.007,2.007,0,0,0,618.643,729.082Z",
    transform: "translate(-618.639 -726.951)",
    fill: "#ff4e7e"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_140846",
    "data-name": "Path 140846",
    d: "M621.718,729.976a2,2,0,0,1-2.043-2.586,2.006,2.006,0,1,0,2.893,2.336A1.986,1.986,0,0,1,621.718,729.976Z",
    transform: "translate(-618.64 -727.109)",
    fill: "#ff2c68",
    opacity: 0.45,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Path_140847",
    "data-name": "Path 140847",
    d: "M623.128,728.981c.157.252.391.39.523.307s.114-.353-.043-.606-.391-.39-.524-.307S622.971,728.729,623.128,728.981Z",
    transform: "translate(-620.212 -727.456)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_25697",
    "data-name": "Group 25697",
    transform: "translate(0 4.648)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25696",
    "data-name": "Group 25696"
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "Path_140848",
    "data-name": "Path 140848",
    d: "M566.935,736.354a2.007,2.007,0,1,0,1.88-2.127A2.007,2.007,0,0,0,566.935,736.354Z",
    transform: "translate(-566.931 -734.223)",
    fill: "#00c1ff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_140849",
    "data-name": "Path 140849",
    d: "M570.01,737.249a2,2,0,0,1-2.043-2.584A2.006,2.006,0,1,0,570.861,737,2,2,0,0,1,570.01,737.249Z",
    transform: "translate(-566.932 -734.383)",
    fill: "#00a2d6",
    opacity: 0.45,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "Path_140850",
    "data-name": "Path 140850",
    d: "M571.328,736c.157.252.391.389.524.307s.113-.353-.043-.605-.391-.39-.523-.307S571.171,735.75,571.328,736Z",
    transform: "translate(-568.47 -734.638)",
    fill: "#fff"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_25715",
    "data-name": "Group 25715",
    transform: "translate(3.021 19.1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25703",
    "data-name": "Group 25703",
    transform: "translate(0 1.33)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25701",
    "data-name": "Group 25701",
    transform: "translate(4.477 8.783)"
  }, _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Group_25700",
    "data-name": "Group 25700"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_140851",
    "data-name": "Path 140851",
    d: "M621.8,789.36q.084-6.923.169-13.846a2.037,2.037,0,0,1-.47.045,3.68,3.68,0,0,1-2.793-1.261c-.052.78-.074,1.776-.093,2.65l-.014.628c-.047,2.019-1.106,3.477-2.7,3.715-1.438.217-3.51-.706-4.6-4.008-1.238-3.739-3.152-4.968-7.061-4.542a9.265,9.265,0,0,0-4.947,1.916,9.021,9.021,0,0,1-4.469,1.869c-1.491.182-3.07-.594-4.6-1.343-.714-.35-2.387-1.17-2.737-.977,0,0-.276.234-.32,1.461-.167,4.71-1.722,7.744-4.16,8.115-1.78.267-3.454-1.039-4.26-3.336a2.568,2.568,0,0,0-.511-.893,9.769,9.769,0,0,0,.346,4.039c.593,2.6.224,4.777-.989,5.82a2.251,2.251,0,0,1-1.332.555,2.156,2.156,0,0,1-.925-.148c-1.27-.5-2.117-2.089-2.386-4.479-.61-5.42-3.846-7.767-6.453-8.781a.549.549,0,0,0-.334-.049c-.447.212-.915,1.635-1.194,2.487a10.941,10.941,0,0,1-.867,2.149,2.058,2.058,0,0,1-2.519,1.108,7.183,7.183,0,0,1-1.9-.99c-.72-.489-.938-.637-2.153-.137-.692.284-.787,2.292-.844,3.491-.078,1.64-.139,2.935-1.184,3.5a1.775,1.775,0,0,1-1.67-.019l3.331,10.694A279.189,279.189,0,0,1,621.8,789.36Z",
    transform: "translate(-553.828 -772.66)",
    fill: "#ff4e7e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_140852",
    "data-name": "Path 140852",
    d: "M559.1,798.56a17.648,17.648,0,0,1-3.376-1.026l2.117,6.8a279.186,279.186,0,0,1,64.641-9.431q.032-2.558.063-5.115a4.064,4.064,0,0,1-2.038.35c-2.331-.226-4.29-2.355-6.618-2.1s-3.757,2.756-5.914,3.7c-2.454,1.078-5.259-.043-7.734-1.07s-5.429-1.938-7.71-.531c-1.476.91-2.329,2.627-3.842,3.474-1.831,1.024-4.123.517-6.087-.221-1.023-.384-2.054-.828-3.1-1.138a4.053,4.053,0,0,1-1.224,2.7,2.252,2.252,0,0,1-1.332.555,2.155,2.155,0,0,1-.925-.148,3.838,3.838,0,0,1-2.027-2.671c-2.259,1.2-4.139,3.412-6.434,4.709A12.489,12.489,0,0,1,559.1,798.56Z",
    transform: "translate(-554.514 -778.2)",
    fill: "#ff2c68"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_140853",
    "data-name": "Path 140853",
    d: "M578.124,790.966l-.019.029c-.024.036-.048.072-.073.107-.044.059-.092.116-.139.172-.024.027-.045.056-.069.081a2.834,2.834,0,0,1-.231.224,2.251,2.251,0,0,1-1.332.555,2.157,2.157,0,0,1-.925-.148,2.3,2.3,0,0,1-.3-.144l-.073-.043a2.49,2.49,0,0,1-.251-.172l-.028-.02a3.171,3.171,0,0,1-.267-.243l-.04-.043a3.427,3.427,0,0,1-.231-.271l-.017-.022a4.583,4.583,0,0,1-.456-.757l0-.008a6.558,6.558,0,0,1-.364-.948,10.278,10.278,0,0,1-.359-1.807c-.61-5.42-3.846-7.767-6.453-8.781a.549.549,0,0,0-.334-.049c-.447.212-.915,1.635-1.194,2.487a10.941,10.941,0,0,1-.867,2.149,2.058,2.058,0,0,1-2.519,1.108,7.183,7.183,0,0,1-1.9-.99c-.72-.489-.938-.637-2.153-.137-.692.284-.787,2.292-.844,3.491-.078,1.64-.139,2.935-1.184,3.5a1.775,1.775,0,0,1-1.67-.019l3.331,10.694a279.239,279.239,0,0,1,28.4-6.054A17.719,17.719,0,0,1,578.124,790.966Z",
    transform: "translate(-553.828 -774.827)",
    fill: "#ff2c68",
    opacity: 0.45,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_25702",
    "data-name": "Group 25702"
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "Path_140854",
    "data-name": "Path 140854",
    d: "M619.695,760.01a3.638,3.638,0,0,0-2.6-1.092,234.145,234.145,0,0,0-67.657,9.871,3.677,3.677,0,0,0-2.445,4.617l2.37,7.61a1.264,1.264,0,0,0,.115.258,4.74,4.74,0,0,0,1.588,1.739,1.844,1.844,0,0,0,1.9.143c1.044-.563,1.106-1.859,1.184-3.5.057-1.2.151-3.206.844-3.491,1.215-.5,1.433-.352,2.153.137a7.182,7.182,0,0,0,1.9.99,2.058,2.058,0,0,0,2.519-1.108,10.943,10.943,0,0,0,.867-2.149c.279-.851.747-2.275,1.194-2.487a.549.549,0,0,1,.334.049c2.607,1.014,5.843,3.361,6.453,8.781.269,2.39,1.117,3.98,2.386,4.479a2.156,2.156,0,0,0,.925.148,2.251,2.251,0,0,0,1.332-.555c1.213-1.043,1.582-3.219.989-5.82a9.77,9.77,0,0,1-.346-4.039,2.568,2.568,0,0,1,.511.893c.805,2.3,2.48,3.6,4.26,3.336,2.438-.371,3.993-3.4,4.16-8.115.043-1.227.317-1.46.32-1.461.35-.193,2.023.626,2.737.977,1.527.748,3.106,1.525,4.6,1.343a9.022,9.022,0,0,0,4.469-1.869,9.265,9.265,0,0,1,4.947-1.916c3.909-.426,5.823.8,7.061,4.542,1.093,3.3,3.165,4.225,4.6,4.008,1.593-.238,2.652-1.7,2.7-3.715l.014-.628c.019-.875.041-1.871.093-2.65a3.68,3.68,0,0,0,2.793,1.261,2.135,2.135,0,0,0,1.033-.244,1.22,1.22,0,0,0,.67-1.074l.081-6.636A3.663,3.663,0,0,0,619.695,760.01Z",
    transform: "translate(-546.824 -758.918)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_140855",
    "data-name": "Path 140855",
    d: "M618.893,771.111c-1.039-.286-1.993-1.361-2.984-.939-.738.315-.915,1.258-1.021,2.053a5.323,5.323,0,0,1-.624,2.134,2.04,2.04,0,0,1-1.849,1.044,2.172,2.172,0,0,1-1.531-1.118,11.642,11.642,0,0,1-.758-1.809c-1.365-3.47-5.114-6-8.806-5.475-2.589.367-4.777,2.048-6.781,3.729,0,0-1.952,1.444-5.553-.481-5.824-3.112-6.172,1.693-6.148,1.729-.7,3.873-4.929,2.881-5.7-2.468A6.448,6.448,0,0,1,579.4,763.6a234.245,234.245,0,0,0-29.959,6.877,3.677,3.677,0,0,0-2.445,4.617l1.832,5.881,2.208,3a3.843,3.843,0,0,1-1.712-1.407l.042.136a1.264,1.264,0,0,0,.115.258,4.74,4.74,0,0,0,1.588,1.739,2.33,2.33,0,0,0,.9.327h.008c.054.006.108.01.16.012h.016a1.7,1.7,0,0,0,.3-.022l.021,0c.042-.007.082-.016.122-.026l.013,0c.043-.012.084-.024.123-.038l.02-.007c.031-.012.062-.024.091-.036l.028-.012c.034-.016.066-.032.1-.049,1.044-.563,1.106-1.859,1.184-3.5.057-1.2.151-3.206.844-3.491,1.215-.5,1.433-.352,2.153.137a7.182,7.182,0,0,0,1.9.99,2.058,2.058,0,0,0,2.519-1.108,10.943,10.943,0,0,0,.867-2.149c.279-.851.747-2.275,1.194-2.487a.549.549,0,0,1,.334.049c2.607,1.014,5.843,3.361,6.453,8.781.269,2.39,1.117,3.98,2.386,4.479a2.156,2.156,0,0,0,.925.148,2.251,2.251,0,0,0,1.332-.555c1.213-1.043,1.582-3.219.989-5.82a9.77,9.77,0,0,1-.346-4.039,2.568,2.568,0,0,1,.511.893c.805,2.3,2.48,3.6,4.26,3.336,2.438-.371,3.993-3.4,4.16-8.115,0-.1.008-.182.015-.265l0-.037c.006-.077.013-.151.02-.219.088-.773.28-.938.282-.94.35-.193,2.023.626,2.737.977,1.527.748,3.106,1.525,4.6,1.343a9.022,9.022,0,0,0,4.469-1.869,9.265,9.265,0,0,1,4.947-1.916c3.909-.426,5.823.8,7.061,4.542,1.093,3.3,3.165,4.225,4.6,4.008,1.593-.238,2.652-1.7,2.7-3.715l.014-.628c.019-.875.041-1.871.093-2.65a3.68,3.68,0,0,0,2.793,1.261,2.135,2.135,0,0,0,1.033-.244,1.22,1.22,0,0,0,.67-1.074l0-.2A2.153,2.153,0,0,1,618.893,771.111Z",
    transform: "translate(-546.824 -760.608)",
    fill: "#00c1ff",
    opacity: 0.08,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_25714",
    "data-name": "Group 25714",
    transform: "translate(4.215)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25705",
    "data-name": "Group 25705",
    transform: "translate(58.052)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25704",
    "data-name": "Group 25704"
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "Path_140856",
    "data-name": "Path 140856",
    d: "M644.256,758.968a2.007,2.007,0,1,0,1.88-2.128A2.007,2.007,0,0,0,644.256,758.968Z",
    transform: "translate(-644.252 -756.837)",
    fill: "#ff4e7e"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_140857",
    "data-name": "Path 140857",
    d: "M647.33,759.844a2.005,2.005,0,0,1-2.033-2.619,2.006,2.006,0,1,0,2.872,2.375A2,2,0,0,1,647.33,759.844Z",
    transform: "translate(-644.252 -756.977)",
    fill: "#ff2c68",
    opacity: 0.45,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "Path_140858",
    "data-name": "Path 140858",
    d: "M648.724,758.611c.157.253.391.39.524.307s.113-.354-.043-.606-.391-.389-.523-.307S648.567,758.359,648.724,758.611Z",
    transform: "translate(-645.818 -757.25)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_25707",
    "data-name": "Group 25707",
    transform: "translate(42.798 5.324)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25706",
    "data-name": "Group 25706"
  }, _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "Path_140859",
    "data-name": "Path 140859",
    d: "M620.389,767.3a2.007,2.007,0,1,0,1.88-2.127A2.007,2.007,0,0,0,620.389,767.3Z",
    transform: "translate(-620.385 -765.168)",
    fill: "#ffe700"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_140860",
    "data-name": "Path 140860",
    d: "M623.463,768.175a2,2,0,0,1-2.033-2.619,2.006,2.006,0,1,0,2.871,2.375A2,2,0,0,1,623.463,768.175Z",
    transform: "translate(-620.385 -765.308)",
    fill: "#ffcb00",
    opacity: 0.45,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    id: "Path_140861",
    "data-name": "Path 140861",
    d: "M624.69,766.923c.156.252.391.389.524.307s.113-.353-.043-.605-.391-.39-.523-.307S624.533,766.671,624.69,766.923Z",
    transform: "translate(-621.891 -765.574)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_25709",
    "data-name": "Group 25709",
    transform: "translate(27.629 2.496)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25708",
    "data-name": "Group 25708"
  }, _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    id: "Path_140862",
    "data-name": "Path 140862",
    d: "M596.653,762.873a2.007,2.007,0,1,0,1.88-2.127A2.007,2.007,0,0,0,596.653,762.873Z",
    transform: "translate(-596.649 -760.742)",
    fill: "#00c1ff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_140863",
    "data-name": "Path 140863",
    d: "M599.727,763.749a2.005,2.005,0,0,1-2.033-2.619,2.006,2.006,0,1,0,2.871,2.375A2,2,0,0,1,599.727,763.749Z",
    transform: "translate(-596.649 -760.882)",
    fill: "#00a2d6",
    opacity: 0.45,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    id: "Path_140864",
    "data-name": "Path 140864",
    d: "M600.991,762.481c.157.252.391.389.523.307s.114-.353-.043-.605-.391-.39-.524-.307S600.834,762.229,600.991,762.481Z",
    transform: "translate(-598.169 -761.142)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_25711",
    "data-name": "Group 25711",
    transform: "translate(16.461 8.149)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25710",
    "data-name": "Group 25710"
  }, _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    id: "Path_140865",
    "data-name": "Path 140865",
    d: "M579.179,771.719a2.007,2.007,0,1,0,1.88-2.128A2.008,2.008,0,0,0,579.179,771.719Z",
    transform: "translate(-579.175 -769.588)",
    fill: "#ff4e7e"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_140866",
    "data-name": "Path 140866",
    d: "M582.254,772.613a2,2,0,0,1-2.043-2.586,2.006,2.006,0,1,0,2.893,2.336A1.994,1.994,0,0,1,582.254,772.613Z",
    transform: "translate(-579.176 -769.746)",
    fill: "#ff2c68",
    opacity: 0.45,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    id: "Path_140867",
    "data-name": "Path 140867",
    d: "M583.664,771.618c.156.252.391.39.523.307s.113-.353-.043-.606-.391-.39-.523-.307S583.507,771.366,583.664,771.618Z",
    transform: "translate(-580.748 -770.093)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_25713",
    "data-name": "Group 25713",
    transform: "translate(0 8.559)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25712",
    "data-name": "Group 25712"
  }, _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    id: "Path_140868",
    "data-name": "Path 140868",
    d: "M553.423,772.36a2.007,2.007,0,1,0,1.88-2.128A2.007,2.007,0,0,0,553.423,772.36Z",
    transform: "translate(-553.419 -770.229)",
    fill: "#00c1ff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_140869",
    "data-name": "Path 140869",
    d: "M556.5,773.256a2,2,0,0,1-2.043-2.584,2.006,2.006,0,1,0,2.894,2.333A2,2,0,0,1,556.5,773.256Z",
    transform: "translate(-553.42 -770.389)",
    fill: "#00a2d6",
    opacity: 0.45,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    id: "Path_140870",
    "data-name": "Path 140870",
    d: "M557.817,772.009c.157.252.391.39.523.307s.113-.353-.043-.605-.391-.39-.523-.307S557.66,771.757,557.817,772.009Z",
    transform: "translate(-554.959 -770.644)",
    fill: "#fff"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_25733",
    "data-name": "Group 25733",
    transform: "translate(0 44.785)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25719",
    "data-name": "Group 25719",
    transform: "translate(0 1.018)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25717",
    "data-name": "Group 25717",
    transform: "translate(6.38 11.088)"
  }, _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "Group_25716",
    "data-name": "Group 25716"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_140871",
    "data-name": "Path 140871",
    d: "M628.761,819.021a4.923,4.923,0,0,1-.337-.591c-.035-.068-.079-.156-.119-.226a.632.632,0,0,0-.243.289,3.873,3.873,0,0,0,0,1.487c.028.242.054.485.071.725a6.9,6.9,0,0,1-2.342,5.806,5.2,5.2,0,0,1-6.472.137,7.991,7.991,0,0,1-2.271-4.355c-.056-.2-.111-.406-.169-.605-.268-.931-.885-2.526-2-2.751a4.236,4.236,0,0,0-1.526.135l-.318.062a16.942,16.942,0,0,1-10.5-1.4c-.376-.183-.742-.378-1.1-.568a11.639,11.639,0,0,0-2.4-1.069,2.676,2.676,0,0,0-2.584.461c-.706.794-.447,2.291-.107,3.406.056.184.115.37.174.556a8.165,8.165,0,0,1,.494,4.819,4.763,4.763,0,0,1-4.218,3.371l-.022,0a4.764,4.764,0,0,1-4.595-2.873,8.028,8.028,0,0,1-.467-1.871,6.7,6.7,0,0,0-.272-1.229,1.155,1.155,0,0,0-.714-.729h0a.911.911,0,0,0-.247.444c-.375,1.159.031,2.515.462,3.95.121.4.246.821.355,1.238.663,2.552.252,5.626-2.162,6.739-2.128.982-4.573-.313-5.619-2.076a8.851,8.851,0,0,1-.859-5.389c.028-.278.061-.557.093-.836a10.453,10.453,0,0,0,.088-2.821,2.456,2.456,0,0,0-1.421-2.011c-.918-.254-1.887.433-3.261,1.509-.383.3-.78.61-1.184.888a8.629,8.629,0,0,1-7.108,1.31,13.882,13.882,0,0,1-1.556-.566,10.7,10.7,0,0,0-1.409-.506,1.958,1.958,0,0,0-1.784.249c-.51.548-.244,1.766.045,2.765l.952,3.3c.738,2.56.41,4.354-.977,5.33a3.031,3.031,0,0,1-2.524.429,4.46,4.46,0,0,1-2.8-2.293,10,10,0,0,1-.815-2.945c-.082-.5-.161-.97-.279-1.411a6.367,6.367,0,0,0-.049,2.422c.033.337.066.685.085,1.037.1,1.848-.493,4.083-2.454,4.813-.068.026-.137.046-.208.066l3.7,11.877a2.927,2.927,0,0,0,2.929,2.046l0,.026,71.657-10.454-.027-.182a2.914,2.914,0,0,0,1.572-2.544q.111-9.083.222-18.166A3.233,3.233,0,0,1,628.761,819.021Z",
    transform: "translate(-552.08 -815.969)",
    fill: "#00c1ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_140872",
    "data-name": "Path 140872",
    d: "M628.221,839.505c-2.884-.221-5.512-1.647-8.236-2.618-3.95-1.409-8.528-1.821-12.205.2-2.892,1.586-5.1,4.58-8.345,5.148-3.185.557-6.191-1.411-9.276-2.379a15.29,15.29,0,0,0-2.985-.614,3.96,3.96,0,0,1-2.049,2.264,4.458,4.458,0,0,1-5.07-1.338,74.64,74.64,0,0,0-7.573,3.877c-2.9,1.488-6.209,2.617-9.38,1.876-3.062-.716-5.547-3.074-8.616-3.756a3.682,3.682,0,0,1-2.2,2.537c-.068.026-.137.046-.208.066l3.7,11.877a2.927,2.927,0,0,0,2.929,2.046l0,.026,71.657-10.454-.027-.182a2.914,2.914,0,0,0,1.572-2.544q.041-3.347.082-6.693A7.854,7.854,0,0,1,628.221,839.505Z",
    transform: "translate(-552.08 -823.09)",
    fill: "#00a2d6"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_140873",
    "data-name": "Path 140873",
    d: "M573.867,831.568a17.058,17.058,0,0,1,2.556-7.255,8.653,8.653,0,0,0-2.277,1.456c-.383.3-.78.61-1.184.888a8.629,8.629,0,0,1-7.108,1.31,13.87,13.87,0,0,1-1.556-.566,10.685,10.685,0,0,0-1.409-.506,2.809,2.809,0,0,0-1.2-.051l-.581.3c-.508.548-.242,1.765.046,2.764l.952,3.3c.738,2.56.41,4.354-.977,5.33a3.031,3.031,0,0,1-2.524.429,4.46,4.46,0,0,1-2.8-2.293,10,10,0,0,1-.815-2.945c-.082-.5-.161-.97-.279-1.411a6.367,6.367,0,0,0-.049,2.422c.033.337.066.685.085,1.037a6.723,6.723,0,0,1-.257,2.276c-.041.136-.088.268-.139.4l-.008.02a4.167,4.167,0,0,1-.628,1.09c-.013.017-.028.032-.042.048q-.105.126-.223.242c-.028.028-.058.054-.088.082q-.1.094-.217.18c-.036.027-.072.056-.109.082-.078.055-.16.1-.245.154-.037.021-.072.044-.111.064a3.267,3.267,0,0,1-.389.176c-.068.026-.137.046-.208.066q1.533,4.919,3.065,9.838l1.224,3.09a2.955,2.955,0,0,0,2.34.995l0,.026,34.983-5.1C580.476,846.533,573.156,839.251,573.867,831.568Z",
    transform: "translate(-552.08 -818.981)",
    fill: "#00a2d6",
    opacity: 0.45,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_25718",
    "data-name": "Group 25718"
  }, _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    id: "Path_140874",
    "data-name": "Path 140874",
    d: "M628.689,799.853a4.1,4.1,0,0,0-2.936-1.233,279.253,279.253,0,0,0-80.7,11.774,4.154,4.154,0,0,0-2.762,5.216l4.664,14.972a1.218,1.218,0,0,0,1.494.811c.081-.023.162-.047.24-.077,1.961-.73,2.554-2.964,2.454-4.812-.018-.351-.052-.7-.085-1.037a6.367,6.367,0,0,1,.049-2.422c.118.442.2.913.279,1.411a10,10,0,0,0,.815,2.945,4.46,4.46,0,0,0,2.8,2.293,3.031,3.031,0,0,0,2.524-.429c1.386-.977,1.715-2.77.977-5.33l-.952-3.3c-.288-1-.555-2.218-.045-2.765a1.958,1.958,0,0,1,1.784-.249,10.7,10.7,0,0,1,1.409.506,13.882,13.882,0,0,0,1.556.566,8.629,8.629,0,0,0,7.108-1.31c.4-.278.8-.589,1.184-.888,1.374-1.076,2.344-1.763,3.261-1.509A2.456,2.456,0,0,1,575.225,817a10.453,10.453,0,0,1-.088,2.821c-.033.279-.066.558-.093.836a8.851,8.851,0,0,0,.859,5.389c1.046,1.763,3.491,3.058,5.619,2.076,2.414-1.113,2.826-4.187,2.162-6.739-.109-.417-.234-.835-.355-1.238-.431-1.435-.837-2.792-.462-3.95a.911.911,0,0,1,.247-.444h0a1.155,1.155,0,0,1,.714.729,6.7,6.7,0,0,1,.272,1.229,8.028,8.028,0,0,0,.467,1.871,4.764,4.764,0,0,0,4.595,2.873l.022,0a4.763,4.763,0,0,0,4.218-3.371,8.165,8.165,0,0,0-.494-4.819c-.059-.186-.118-.372-.174-.556-.341-1.115-.6-2.611.107-3.406a2.676,2.676,0,0,1,2.584-.461,11.639,11.639,0,0,1,2.4,1.069c.354.189.72.385,1.1.568a16.942,16.942,0,0,0,10.5,1.4l.318-.062a4.236,4.236,0,0,1,1.526-.135c1.117.225,1.733,1.82,2,2.751.057.2.113.4.169.605a7.991,7.991,0,0,0,2.271,4.355,5.2,5.2,0,0,0,6.472-.137,6.9,6.9,0,0,0,2.342-5.806c-.017-.24-.043-.483-.071-.725a3.873,3.873,0,0,1,0-1.487.632.632,0,0,1,.243-.289c.04.07.084.158.119.226a4.923,4.923,0,0,0,.337.591,3.3,3.3,0,0,0,3.732,1.141,1.218,1.218,0,0,0,.877-1.155l.121-9.916A4.135,4.135,0,0,0,628.689,799.853Z",
    transform: "translate(-542.097 -798.619)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_140875",
    "data-name": "Path 140875",
    d: "M627.523,814.715c-.962-.6-1.834-1.547-2.965-1.525-1.729.033-2.483,2.174-2.714,3.888s-.788,3.856-2.5,4.115c-1.349.2-2.5-1-3.088-2.235s-.9-2.642-1.846-3.624c-2.076-2.151-5.625-1.04-8.608-1.255-3.394-.244-6.36-2.386-9.686-3.1a5.7,5.7,0,0,0-4.967.862c-1.973,1.736-1.556,4.86-.993,7.426.224,1.021.355,2.3-.49,2.912-1.156.84-2.693-.514-3.185-1.855s-.771-3-2.06-3.614c-1.323-.632-2.96.369-3.548,1.713a8.3,8.3,0,0,0-.24,4.337q.189,1.532.377,3.065a2.249,2.249,0,0,1-.169,1.518c-.531.811-1.9.541-2.455-.251a4.827,4.827,0,0,1-.564-2.8,48.065,48.065,0,0,0-.273-4.823,4.891,4.891,0,0,0-1.245-3.259,3.377,3.377,0,0,0-3.091-.546h0a6.16,6.16,0,0,0-1.088.377c-1.287.258-3.245-.032-3.141-4.251a6.54,6.54,0,0,1,3.118-5.164q-13.663,2.651-27.053,6.663a4.154,4.154,0,0,0-2.762,5.216l4.664,14.972a1.223,1.223,0,0,0,.146.3h0a1.2,1.2,0,0,0,.1.128l0,0a1.22,1.22,0,0,0,.346.276l.031.018c.029.015.061.027.092.039s.054.022.082.031.053.016.081.022a1.074,1.074,0,0,0,.112.022c.022,0,.043.007.065.009a1.185,1.185,0,0,0,.185,0,1.229,1.229,0,0,0,.256-.043c.081-.023.162-.047.24-.077,1.961-.73,2.554-2.964,2.454-4.812-.018-.352-.052-.7-.085-1.037a6.367,6.367,0,0,1,.049-2.422c.118.442.2.913.279,1.411a10,10,0,0,0,.815,2.945,4.46,4.46,0,0,0,2.8,2.293,3.031,3.031,0,0,0,2.524-.429c1.386-.977,1.715-2.77.977-5.33l-.952-3.3c-.288-1-.555-2.218-.045-2.765a1.958,1.958,0,0,1,1.784-.249,10.685,10.685,0,0,1,1.409.506,13.87,13.87,0,0,0,1.556.566,8.629,8.629,0,0,0,7.108-1.31c.4-.278.8-.589,1.184-.888.176-.139.346-.27.51-.394,1.112-.843,1.951-1.336,2.751-1.115a2.456,2.456,0,0,1,1.421,2.011,10.453,10.453,0,0,1-.088,2.821c-.033.279-.066.558-.093.836a8.851,8.851,0,0,0,.859,5.389c1.046,1.763,3.491,3.058,5.619,2.076,2.414-1.113,2.826-4.187,2.162-6.739-.109-.417-.234-.835-.355-1.238-.431-1.435-.837-2.792-.462-3.95a.911.911,0,0,1,.247-.444h0a1.155,1.155,0,0,1,.714.729,6.7,6.7,0,0,1,.272,1.229,8.028,8.028,0,0,0,.467,1.871,4.764,4.764,0,0,0,4.595,2.873l.022,0a4.763,4.763,0,0,0,4.218-3.371,8.164,8.164,0,0,0-.494-4.819c-.059-.186-.118-.372-.174-.556-.341-1.115-.6-2.611.107-3.406a2.676,2.676,0,0,1,2.584-.461,11.636,11.636,0,0,1,2.4,1.069c.354.189.72.385,1.1.568a16.942,16.942,0,0,0,10.5,1.4l.318-.062a4.236,4.236,0,0,1,1.526-.135c1.117.225,1.733,1.82,2,2.751.057.2.113.4.169.605a7.992,7.992,0,0,0,2.271,4.356,5.2,5.2,0,0,0,6.472-.137,6.9,6.9,0,0,0,2.342-5.806c-.017-.24-.043-.483-.071-.725a3.873,3.873,0,0,1,0-1.487.631.631,0,0,1,.243-.289c.04.07.084.158.119.226a4.928,4.928,0,0,0,.337.591,3.3,3.3,0,0,0,3.732,1.141,1.218,1.218,0,0,0,.877-1.155l.008-.693A2.544,2.544,0,0,1,627.523,814.715Z",
    transform: "translate(-542.097 -801.506)",
    fill: "#00c1ff",
    opacity: 0.08,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_25732",
    "data-name": "Group 25732",
    transform: "translate(6.182)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25721",
    "data-name": "Group 25721",
    transform: "translate(72.961 5.304)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25720",
    "data-name": "Group 25720"
  }, _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    id: "Path_140876",
    "data-name": "Path 140876",
    d: "M665.935,807.456a2.007,2.007,0,1,0,1.88-2.128A2.007,2.007,0,0,0,665.935,807.456Z",
    transform: "translate(-665.931 -805.325)",
    fill: "#ff4e7e"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_140877",
    "data-name": "Path 140877",
    d: "M669.009,808.332a2.005,2.005,0,0,1-2.033-2.619,2.006,2.006,0,1,0,2.872,2.376A2.013,2.013,0,0,1,669.009,808.332Z",
    transform: "translate(-665.931 -805.465)",
    fill: "#ff2c68",
    opacity: 0.45,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    id: "Path_140878",
    "data-name": "Path 140878",
    d: "M670.4,807.1c.157.253.391.39.524.307s.113-.353-.043-.606-.391-.389-.523-.307S670.247,806.847,670.4,807.1Z",
    transform: "translate(-667.498 -805.738)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_25723",
    "data-name": "Group 25723",
    transform: "translate(32.514 2.595)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25722",
    "data-name": "Group 25722"
  }, _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    id: "Path_140879",
    "data-name": "Path 140879",
    d: "M602.648,803.217a2.007,2.007,0,1,0,1.88-2.127A2.007,2.007,0,0,0,602.648,803.217Z",
    transform: "translate(-602.644 -801.086)",
    fill: "#ffe700"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_140880",
    "data-name": "Path 140880",
    d: "M605.722,804.092a2,2,0,0,1-2.033-2.619,2.006,2.006,0,1,0,2.872,2.376A1.992,1.992,0,0,1,605.722,804.092Z",
    transform: "translate(-602.644 -801.226)",
    fill: "#ffcb00",
    opacity: 0.45,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    id: "Path_140881",
    "data-name": "Path 140881",
    d: "M606.949,802.841c.157.253.391.39.524.307s.113-.353-.043-.606-.391-.389-.523-.307S606.792,802.589,606.949,802.841Z",
    transform: "translate(-604.15 -801.492)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_25725",
    "data-name": "Group 25725",
    transform: "translate(61.351)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25724",
    "data-name": "Group 25724"
  }, _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    id: "Path_140882",
    "data-name": "Path 140882",
    d: "M647.769,799.157a2.007,2.007,0,1,0,1.88-2.127A2.007,2.007,0,0,0,647.769,799.157Z",
    transform: "translate(-647.765 -797.026)",
    fill: "#ffe700"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_140883",
    "data-name": "Path 140883",
    d: "M650.844,800.032a2,2,0,0,1-2.033-2.619,2.006,2.006,0,1,0,2.871,2.376A2.007,2.007,0,0,1,650.844,800.032Z",
    transform: "translate(-647.765 -797.166)",
    fill: "#ffcb00",
    opacity: 0.45,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    id: "Path_140884",
    "data-name": "Path 140884",
    d: "M652.178,798.847c.157.252.391.39.523.307s.113-.353-.043-.605-.391-.39-.523-.307S652.021,798.595,652.178,798.847Z",
    transform: "translate(-649.31 -797.456)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_25727",
    "data-name": "Group 25727",
    transform: "translate(48.85 4.919)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25726",
    "data-name": "Group 25726"
  }, _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    id: "Path_140885",
    "data-name": "Path 140885",
    d: "M628.208,806.854a2.007,2.007,0,1,0,1.88-2.128A2.007,2.007,0,0,0,628.208,806.854Z",
    transform: "translate(-628.204 -804.723)",
    fill: "#00c1ff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_140886",
    "data-name": "Path 140886",
    d: "M631.282,807.73a2,2,0,0,1-2.032-2.619,2.006,2.006,0,1,0,2.871,2.375A2,2,0,0,1,631.282,807.73Z",
    transform: "translate(-628.204 -804.863)",
    fill: "#00a2d6",
    opacity: 0.45,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    id: "Path_140887",
    "data-name": "Path 140887",
    d: "M632.546,806.462c.157.252.391.389.524.307s.113-.353-.043-.606-.391-.39-.523-.307S632.389,806.21,632.546,806.462Z",
    transform: "translate(-629.724 -805.123)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_25729",
    "data-name": "Group 25729",
    transform: "translate(17.075 10.111)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25728",
    "data-name": "Group 25728"
  }, _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    id: "Path_140888",
    "data-name": "Path 140888",
    d: "M578.491,814.977a2.007,2.007,0,1,0,1.88-2.128A2.007,2.007,0,0,0,578.491,814.977Z",
    transform: "translate(-578.487 -812.846)",
    fill: "#ff4e7e"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_140889",
    "data-name": "Path 140889",
    d: "M581.566,815.871a2,2,0,0,1-2.043-2.586,2.006,2.006,0,1,0,2.893,2.336A1.986,1.986,0,0,1,581.566,815.871Z",
    transform: "translate(-578.488 -813.004)",
    fill: "#ff2c68",
    opacity: 0.45,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    id: "Path_140890",
    "data-name": "Path 140890",
    d: "M582.976,814.876c.157.252.391.39.523.307s.114-.354-.043-.606-.391-.39-.524-.307S582.819,814.624,582.976,814.876Z",
    transform: "translate(-580.06 -813.351)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_25731",
    "data-name": "Group 25731",
    transform: "translate(0 9.062)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25730",
    "data-name": "Group 25730"
  }, _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    id: "Path_140891",
    "data-name": "Path 140891",
    d: "M551.774,813.336a2.007,2.007,0,1,0,1.88-2.127A2.007,2.007,0,0,0,551.774,813.336Z",
    transform: "translate(-551.77 -811.205)",
    fill: "#00c1ff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_140892",
    "data-name": "Path 140892",
    d: "M554.849,814.231a2,2,0,0,1-2.043-2.584,2.006,2.006,0,1,0,2.894,2.333A2,2,0,0,1,554.849,814.231Z",
    transform: "translate(-551.771 -811.364)",
    fill: "#00a2d6",
    opacity: 0.45,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    id: "Path_140893",
    "data-name": "Path 140893",
    d: "M556.167,812.984c.157.252.391.389.524.307s.113-.353-.043-.605-.391-.39-.523-.307S556.01,812.732,556.167,812.984Z",
    transform: "translate(-553.309 -811.62)",
    fill: "#fff"
  })))))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "Group_25735",
    "data-name": "Group 25735",
    transform: "translate(59.098 12.28)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_140894",
    "data-name": "Path 140894",
    d: "M637.738,746.165l-.107,7.063-3.065.189S637.418,752.7,637.738,746.165Z",
    transform: "translate(-634.567 -746.165)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_140895",
    "data-name": "Path 140895",
    d: "M656.384,784.533l-.073,7.6-2.349.055S656.121,790.52,656.384,784.533Z",
    transform: "translate(-641.567 -760.012)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_140896",
    "data-name": "Path 140896",
    d: "M671.2,829.408l.176,13.83-4.706.7S671.452,842.284,671.2,829.408Z",
    transform: "translate(-646.152 -776.207)",
    fill: "#fff"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBirthday);
export default __webpack_public_path__ + "static/media/Birthday.b37035cdf631e4ae354bb1f8b984ded3.svg";
export { ForwardRef as ReactComponent };